import PageCard from "features/shared/components/card/PageCard";
import SelectInput from "features/shared/components/selectInput/SelectInput";
import DistributionRateTypeEnumDTO from "features/shared/enums/dynamic/DistributionRateTypeEnumDTO";
import FormGroup from "features/shared/forms/components/FormGroup";
import React from "react";
import { useTranslation } from "react-i18next";

interface OptionType {
  value: string;
  name: string;
}

const phases: OptionType[] = [
  { value: "1", name: "1" },
  { value: "3", name: "3" },
];

interface Props {
  bindField: any;
  values: Record<string, string>;
  errors: Record<string, string>;
  distributionRates: DistributionRateTypeEnumDTO[];
  editable: boolean;
}

const DistRateCircuitBreakerSubForm = ({
  bindField,
  errors,
  values,
  distributionRates,
  editable,
}: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  if (editable) {
    return (
      <div className="row no-gutters mx-n2 mt-2">
        <div className="col-lg-6 px-2">
          <PageCard title={tLabels("distRateCircuitBreakerSubForm.cardTitle")} bodyClassName="pt-4 px-4">
            <FormGroup labelText={tLabels("distRateCircuitBreakerSubForm.phase")}>
              <input
                className="form-control"
                disabled
                defaultValue={values["DESC_TMZMSMLEEFAZEPUVODNI"] ?? ""}
              />
            </FormGroup>
            <FormGroup labelText={tLabels("distRateCircuitBreakerSubForm.circuitBreaker")}>
              <div className="input-group">
                <input className="form-control" disabled defaultValue={values["DESC_TMZMSMLEEJISTICPUVOD"] ?? ""} />
                <div className="input-group-append">
                  <span className="input-group-text">A</span>
                </div>
              </div>
            </FormGroup>
            <FormGroup labelText={tLabels("distRateCircuitBreakerSubForm.distributionRate")}>
              <input
                className="form-control"
                disabled
                defaultValue={values["DESC_TMZMSMLEESAZBAPUV"] ?? ""}
              />
            </FormGroup>
          </PageCard>
        </div>
        <div className="col-lg-6 px-2">
          <PageCard title={tLabels("distRateCircuitBreakerSubForm.requiredValues")} bodyClassName="pt-4 px-4">
            <SelectInput 
              options={phases} 
              optionName="name"
              optionValue="value"
              label={tLabels("distRateCircuitBreakerSubForm.phase")}
              {...bindField("DESC_TMZMSMLEEFAZE")} 
            />
            <FormGroup 
              labelText={tLabels("distRateCircuitBreakerSubForm.circuitBreaker")}
              validationError={errors ? errors["DESC_TMZMSMLEEJISTIC"] : undefined}
            >
              <div className="input-group">
                <input className="form-control" placeholder={tLabels("distRateCircuitBreakerSubForm.setValueCircuitBreaker")} {...bindField("DESC_TMZMSMLEEJISTIC")} />
                <div className="input-group-append">
                  <span className="input-group-text">A</span>
                </div>
              </div>
            </FormGroup>
            <SelectInput 
              options={distributionRates} 
              optionName="code"
              optionValue="code"
              label={tLabels("distRateCircuitBreakerSubForm.distributionRate")}
              {...bindField("DESC_TMZMSMLEESAZBA")} 
            />
          </PageCard>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default DistRateCircuitBreakerSubForm;
